export function Logo({ className = "h-8 w-8" }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <rect width="64" height="64" rx="14" fill="currentColor" />
      <path
        d="M20 22h24M20 32h24M20 42h14"
        stroke="#fff"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <circle cx="46" cy="42" r="6" fill="#ff9f1c" />
    </svg>
  );
}

export function Wordmark({ className = "" }: { className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2 font-extrabold tracking-tight ${className}`}>
      <Logo className="h-7 w-7 text-brand-600" />
      <span>
        Edu<span className="text-brand-600">Pause</span>
      </span>
    </span>
  );
}
